import { Injectable } from '@angular/core';
import { RestService } from '../rest/rest.service';

@Injectable()
export class TramiteConsultaQRService extends RestService {
  public Controller = "Qr";

  public GetTramiteQR(caller: any, valor: any, returnFunction: Function | undefined = undefined) {
    this.http.post(this.baseUrl + "/" + this.Controller + "/GetTramiteQR", valor).subscribe({ next: this.SuscriveResult(caller, returnFunction), error: this.SuscriveFault(caller, returnFunction) });
  }

  public GetConstanciaQR(caller: any, valor: any, returnFunction: Function | undefined = undefined) {
    this.http.post(this.baseUrl + "/" + this.Controller + "/GetConstanciaQR", valor).subscribe({ next: this.SuscriveResult(caller, returnFunction), error: this.SuscriveFault(caller, returnFunction) });
  }

  public ReImpresion(caller: any, idTramite: number, idImpresion: number, nombreArchivo: string, returnFunction: Function | undefined = undefined) {
    this.http.post(this.baseUrl + "/" + this.Controller + "/ReImpresion/" + idTramite + "/" + idImpresion, null, {
      responseType: 'blob' as 'json'
    }).subscribe(this.SuscriveDownloadFileResult(caller, nombreArchivo + ".pdf", returnFunction), this.SuscriveFault(caller, returnFunction));
  }

}
